export const LoyaltySignInType = {
  Phone: 1,
  Email: 2,
} as const;

export type LoyaltySignInType =
  (typeof LoyaltySignInType)[keyof typeof LoyaltySignInType];

// helpers for flag math
export function hasFlag(value: number, flag: LoyaltySignInType): boolean {
  return (value & flag) === flag;
}